export default {
  clueListData: state => state.clueListData,
  allSalesman: state => state.allSalesman,
  detail: state => state.detail,
  searchCustomerList: state => state.searchCustomerList,
  transferDetail: state => state.transferDetail,
  clueVisit: state => state.clueVisit,
};
